"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var StatesButton_st_css_1 = require("./StatesButton.st.css");
var Button_1 = require("../Button");
var constants_1 = require("./constants");
var deprecationLog_1 = require("../../common/deprecationLog");
var StatesButton = /** @class */ (function (_super) {
    __extends(StatesButton, _super);
    function StatesButton(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (_a) {
            var prevState = _a.state;
            var _b = _this.props, currentState = _b.state, onNotificationEnd = _b.onNotificationEnd;
            if (currentState !== prevState) {
                clearTimeout(_this.timer);
            }
            if ((currentState === constants_1.BUTTON_STATES.SUCCESS &&
                prevState !== constants_1.BUTTON_STATES.SUCCESS) ||
                (currentState === constants_1.BUTTON_STATES.FAILURE &&
                    prevState !== constants_1.BUTTON_STATES.FAILURE)) {
                _this.timer = setTimeout(function () { return onNotificationEnd && onNotificationEnd(); }, 2000);
            }
        };
        _this.buttonRef = React.createRef();
        _this.focus = function () {
            _this.buttonRef.current.focus();
        };
        _this.debounceOnClick = function (e) {
            var _a = _this.props, state = _a.state, onClick = _a.onClick;
            if (state === constants_1.BUTTON_STATES.IDLE) {
                onClick(e);
            }
        };
        deprecationLog_1.wrap('Button');
        return _this;
    }
    StatesButton.prototype.componentDidMount = function () {
        if (!this.props.upgrade) {
            deprecationLog_1.deprecationLog('StatesButton', 'The current `StatesButton` component API will be deprecated in the next major version. Please use the `upgrade` prop in order to use the new API.');
            deprecationLog_1.unwrap('Button');
        }
    };
    StatesButton.prototype.renderCheck = function () {
        return (React.createElement("div", { className: classNames(StatesButton_st_css_1.default.successIcon) },
            React.createElement(Check, { size: "1em", "data-hook": 'checkIcon' })));
    };
    StatesButton.prototype.renderContent = function () {
        var _a = this.props, state = _a.state, idleContent = _a.idleContent, inProgressContent = _a.inProgressContent, failureContent = _a.failureContent, successContent = _a.successContent;
        switch (state) {
            case constants_1.BUTTON_STATES.IDLE:
                return idleContent;
            case constants_1.BUTTON_STATES.IN_PROGRESS:
                return inProgressContent;
            case constants_1.BUTTON_STATES.FAILURE:
                return failureContent;
            case constants_1.BUTTON_STATES.SUCCESS:
                return successContent ? successContent : this.renderCheck();
            default:
                return idleContent;
        }
    };
    StatesButton.prototype.render = function () {
        var _a = this.props, state = _a.state, disabled = _a.disabled, onClick = _a.onClick, idleContent = _a.idleContent, inProgressContent = _a.inProgressContent, failureContent = _a.failureContent, successContent = _a.successContent, onNotificationEnd = _a.onNotificationEnd, upgrade = _a.upgrade, rest = __rest(_a, ["state", "disabled", "onClick", "idleContent", "inProgressContent", "failureContent", "successContent", "onNotificationEnd", "upgrade"]);
        var inProgress = state === constants_1.BUTTON_STATES.IN_PROGRESS;
        return (React.createElement(Button_1.Button, __assign({ upgrade: upgrade, disabled: disabled, onClick: this.debounceOnClick, ref: this.buttonRef, "aria-live": "assertive" }, (inProgress && { 'aria-busy': true }), rest, StatesButton_st_css_1.default('root', { upgrade: upgrade }, this.props)), this.renderContent()));
    };
    return StatesButton;
}(React.Component));
exports.StatesButton = StatesButton;
var Check = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 12", fill: "currentColor", width: size || '16', height: size || '12' }, props),
        React.createElement("g", { stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-58 -14)", fill: "currentColor" },
                React.createElement("g", { transform: "translate(54 8)" },
                    React.createElement("path", { d: "M18.3136362,7.71301485 L18.6360088,7.36934666 L18.6353838,7.34268869 L18.2990357,7.69884361 L18.3136362,7.71301485 Z M5.31339777,12.4034164 L5.31535398,12.4279974 L5.68535858,12.7239424 L5.69635283,12.7097196 L5.31339777,12.4034164 Z M18.2802035,6.28698515 L19.7009643,7.66597596 L10.3083211,17.6790879 L4.30364717,12.8763019 L5.51599094,11.3079495 L10.1177586,14.9886332 L18.2802035,6.28698515 Z" }))))));
};
//# sourceMappingURL=StatesButton.js.map